export const colors: string[] = [
  '#e2b08a', // 0
  '#d98a63', // 1
  '#f44763', // 2
  '#e484af', // 3
  '#ba73d7', // 4
  '#4f81ee', // 5
  '#72b6ea', // 6
  '#6fd7ea', // 7
  '#4ccfa6', // 8
  '#59d36b', // 9
  '#a8d84d', // 10
  '#e6d24a', // 11
];